module.exports = __webpack_public_path__ + "static/media/Paytm-for-business-app.02b5fa04.jpg";